/**
 * Read More Mobile Accordion
 * Shows first paragraph and toggle button on mobile, full content on desktop
 * 
 * @param {Object} deviceData - Device information from getDevice()
 */
function readMoreMobile(deviceData) {
  const readMoreElements = document.querySelectorAll('[data-read-more]')
  
  if (!readMoreElements.length) return
  
  readMoreElements.forEach(wrapper => {
    // Get configuration from data attributes
    const showParagraphs = parseInt(wrapper.dataset.showParagraphs) || 1
    const textMore = wrapper.dataset.textMore || 'Leer más'
    const textLess = wrapper.dataset.textLess || 'Cerrar'
    
    const contentDiv = wrapper.querySelector('.read-more-content')
    const paragraphs = contentDiv.querySelectorAll('p')
    
    // Skip if not enough paragraphs
    if (paragraphs.length <= showParagraphs) return
    
    // Only apply on mobile/tablet
    if (deviceData.isMobile || deviceData.isTablet) {
      
      // Create toggle button if it doesn't exist
      let toggleBtn = wrapper.querySelector('.read-more-toggle')
      if (!toggleBtn) {
        toggleBtn = document.createElement('button')
        toggleBtn.className = 'read-more-toggle'
        toggleBtn.innerHTML = `<span class="read-more-text">${textMore}</span><span class="read-more-icon">+</span>`
        toggleBtn.setAttribute('aria-expanded', 'false')
        wrapper.appendChild(toggleBtn)
      }
      
      // Hide paragraphs after the first one
      paragraphs.forEach((p, index) => {
        if (index >= showParagraphs) {
          p.classList.add('read-more-hidden')
        }
      })
      
      // Add collapsed state to wrapper
      wrapper.classList.add('read-more-collapsed')
      
      // Toggle functionality
      toggleBtn.addEventListener('click', () => {
        const isExpanded = wrapper.classList.toggle('read-more-expanded')
        wrapper.classList.toggle('read-more-collapsed')
        
        // Update button
        const textSpan = toggleBtn.querySelector('.read-more-text')
        const iconSpan = toggleBtn.querySelector('.read-more-icon')
        
        if (isExpanded) {
          textSpan.textContent = textLess
          iconSpan.textContent = '−'
          toggleBtn.setAttribute('aria-expanded', 'true')
        } else {
          textSpan.textContent = textMore
          iconSpan.textContent = '+'
          toggleBtn.setAttribute('aria-expanded', 'false')
        }
        
        // Las clases en los párrafos permanecen, CSS maneja la visibilidad con transiciones
      })
      
    } else {
      // Desktop: ensure everything is visible and remove button
      paragraphs.forEach(p => p.classList.remove('read-more-hidden'))
      wrapper.classList.remove('read-more-collapsed', 'read-more-expanded')
      const toggleBtn = wrapper.querySelector('.read-more-toggle')
      if (toggleBtn) toggleBtn.remove()
    }
  })
}

export default readMoreMobile
